import * as mdiIcons from "@mdi/js";
import { customIconPaths } from "~/utils/custom-icons";

// Convert kebab-case icon name to mdi camelCase export name
// e.g. "chevron-down" → "mdiChevronDown", "account-group" → "mdiAccountGroup"
function toMdiExportName(name: string): string {
  return (
    "mdi" +
    name
      .split("-")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join("")
  );
}

// Cache for resolved icon paths
const cache = new Map<string, string | null>();

/**
 * Resolve an icon name to its SVG path data.
 * Accepts: "chevron-down", "mdi-chevron-down", "$chevron-down"
 * Custom icons from svgrepo: added via scripts/fetch-svg.ts
 */
export function resolveIcon(name: string): string | null {
  if (!name) return null;

  // Strip "mdi-" or "$" prefix
  const clean = name.replace(/^mdi-/, "").replace(/^\$/, "");

  if (cache.has(clean)) return cache.get(clean)!;

  // 1. Custom Icons (svgrepo.com, via scripts/fetch-svg.ts)
  const custom = customIconPaths[clean];
  if (custom) {
    cache.set(clean, custom);
    return custom;
  }

  // 2. MDI Icons
  const exportName = toMdiExportName(clean);
  const path = (mdiIcons as Record<string, string>)[exportName] || null;

  cache.set(clean, path);
  return path;
}

// Legacy export for backwards compatibility
export const iconAliases: Record<string, string> = new Proxy(
  {},
  {
    get(_target, prop: string) {
      return resolveIcon(prop) || prop;
    },
  },
);
